import type { FaireProductEntity } from "../../entity_types/product";

export const p_m59xpenuff: FaireProductEntity = {
  token: "p_m59xpenuff",
  type: "product",
  name: "Multi Surface Cleaner Refill Tablets",
  brandToken: "b_qpbga97kpu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/173f4e3c846d0528a2c806d936116b6b2f5272e6737e6db1e59189e7c97c3cbc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eb21b2756bbe3971337fafc106a1d24ba6e5d55dc5cfb8835a4a88093ece2151.jpeg",
    "https://cdn.faire.com/fastly/cda03c8e7fa0888154b3982a663f3569971b4b0fd08823772f00e615b3d01caf.jpeg",
    "https://cdn.faire.com/fastly/44032868095486811da639c7b462cfe47a7039a7fbab262f84ba012f99e964ca.jpeg",
    "https://cdn.faire.com/fastly/5378a2bbb52557bdb92401e5f3cdf13f77749cd97a98fa092c88312639f64472.jpeg",
  ],
  priceDollars: 10.5,
  description:
    "The Cleaning Essential You Need for Every Season!\n\nFomin has you covered with clean, conscious, and convenient cleaning alternatives that keep up with whatever life throws at you. Featured on The Today Show, CNN, People, Buzzfeed, and more, Fomin is the eco-friendly cleaning solution trusted by households and retailers alike.\n\nHow to Use:\nSimply drop one Lemon Zest All-Purpose Cleaning Tablet into a reusable 17oz spray dispenser, fill with warm water, and wait 10 minutes. The tablet dissolves into a powerful, non-toxic cleaner spray—safe, effective, and perfect for every surface in your home.\n\nThe Sustainable Cleaning Solution\n\t• Plastic Bank certified, cruelty-free, 100% vegan, and carbon-neutral\n\t• Packaged in 100% TUV-Certified compostable material\n\t• More sustainable and more affordable than leading conventional cleaners\n\nWhy Retailers Love It:\n\t• At just $2.00 per tablet, shoppers save roughly $4 per purchase compared to traditional cleaners\n\t• Eco-conscious product that delivers repeat sales and stronger margins\n\t• Fast-moving essential with broad seasonal appeal\n\nNow available in refreshing Lemon Zest – a bright, uplifting fragrance that makes cleaning feel fresh and effortless.\n",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:01.783Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
